<template>
  <b-modal id="model-list" title="Aggiungi Modelli" scrollable size="xl"
           ok-variant="success" @ok="save()" @cancel="clearData()">
    <filter-area
      @filterData="filterData()"
      @resetData="resetFilerAreaData()"
    >
      <b-row>
        <b-col cols="3">
          <b-form-group>
            <label for="code">{{$t('filterArea.label.code')}}</label>
            <b-form-input
              type="text"
              id="code"
              :placeholder="$t('filterArea.label.code')"
              v-model="filterArea.code">
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group>
            <label for="name">{{$t('filterArea.label.description')}}</label>
            <b-form-input
              type="text"
              id="name"
              :placeholder="$t('filterArea.label.description')"
              v-model="filterArea.description">
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group>
            <label for="code">{{$t('filterArea.label.category')}}</label>
            <v-select v-model="filterArea.categories" :reduce="category => category.code" multiple :options="categories"></v-select>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group>
            <label for="name">{{$t('filterArea.label.format')}}</label>
            <v-select
              v-model="filterArea.format"
              :options="formats"
            ></v-select>
          </b-form-group>
        </b-col>
      </b-row>
    </filter-area>
    <div class="jumbotron border-dark border" v-if="items.length == 0">
      <h3>{{ $t('page.noModelAvailbale') }}</h3>
      <p class="lead">{{ $t('page.allModelAdded') }}</p>
    </div>
    <div v-else>
      <b-table
        :stacked="stacked"
        :hover="hover"
        :striped="striped"
        :bordered="bordered"
        :small="small"
        :fixed="fixed"
        :items="items"
        :fields="captions"
        :current-page="1"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :per-page="perPage"
        @sort-changed="sortingChanged"
        :no-sort-reset="true"
        :no-local-sorting="true">
        <template slot="actions" slot-scope="data">
          <b-form-checkbox
            :key="data.item.code"
            :checked="isModelChecked(data.item.code)"
            @change="selectModel($event, data.item)"
          ></b-form-checkbox>
        </template>
        <template slot="categories" slot-scope="data">
          <b-badge v-for="category in data.item.categories" :key="category.id" :variant="`warning`" class="mx-1">
            {{category.code}}
          </b-badge>
        </template>
        <template slot="description" slot-scope="data">
          <span>{{data.item.description}}</span>
        </template>
      </b-table>
      <div class="row">
        <div class="col-sm-4">
          <b-pagination :total-rows="rowCount" :per-page="perPage" v-model="currentPage" prev-text="Prec"
                        next-text="Succ" hide-goto-end-buttons @input="fetchData(currentPage)"/>
        </div>
      </div>
      <div class="row" v-if="selectedModels.length > 0">
        <div class="col-sm-12">
          <b>Modelli Selezionati:</b> {{ selectedModels.map(element => element.code).join(', ') }}
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
  import ModelService from "@/services/ModelService"
  import i18n from '@/config/i18n'
  import FilterArea from '../../components/FilterArea'
  import vSelect from 'vue-select'

  const modelService = ModelService.build();

  export default {
    props: {
      stacked: {
        type: String,
        default: 'sm'
      },
      hover: {
        type: Boolean,
        default: true
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      },
      perPage: {
        type: Number,
        default: 7
      }
    },
    data() {
      return {
        selectedModels: [],
        fields: [
          {
            key: 'actions',
            sortable: false,
            label: ''
          },
          {
            key: 'code',
            sortable: true,
            label: i18n.t('page.generic.code')
          },
          {
            key: 'modelVersion',
            sortable: true,
            label: i18n.t('page.generic.version'),
            formatter: this.versionFormatter
          },
          {
            key: 'modelFormat',
            sortable: true,
            label: i18n.tc('page.generic.format', 1)
          },
          {
            key: 'description',
            sortable: true,
            label: i18n.t('page.generic.description')
          },
          {
            key: 'categories',
            sortable: false,
            label: i18n.tc('title.categories', 1)
          },
        ],
        currentPage: 1,
        tableData: [],
        tableTotalRows: 0,
        sortBy: 'code',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterArea: {},
        formats:[],
        categories:[]
      }
    },
    components: {
      FilterArea,
      vSelect
    },
    methods: {
      save() {
        this.$emit('addModels', this.selectedModels);
        this.clearData();
      },
      clearData() {
        this.selectedModels = [];
        this.currentPage = 1;
      },
      sortingChanged(ctx) {
        // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
        // ctx.sortDesc ==> true if sorting descending, false otherwise
        this.sortBy = ctx.sortBy;
        this.sortDesc = ctx.sortDesc;
        this.fetchData(this.currentPage)
      },
      async fetchData(currentPage) {
        (
          {
            data: this.tableData = [],
            total: this.tableTotalRows = 0
          } = await modelService.search(
            {
              max: this.perPage,
              offset: (currentPage - 1) * this.perPage,
              sort: this.sortBy,
              order: (this.sortDesc ? 'desc' : 'asc'),
              enabled: true,
              code: this.filterArea.code,
              description: this.filterArea.description,
              fCategories: this.categoryFilters,
              modelFormat: this.filterArea.format
            }
          )
        )
      },
      selectModel(event, element) {
        if(event === true) {
          this.selectedModels.push(element);
        } else {
          this.selectedModels.splice(this.selectedModels.findIndex(item => item.code === element.code), 1)
        }
      },
      isModelChecked(modelCode) {
        return this.selectedModels.findIndex(element => element.code === modelCode) !== -1;
      },
      versionFormatter(value) {
        return `V-${value < 10 ? '0' + value : value}`
      },
      getFormats() {
        this.$http.get(`api/models/formats`)
          .then(response => response.json())
          .then(json => {
            this.formats = json.map(function (format) {
              return format.name
            })
          })
      },
      getCategories() {
        this.$http.get(`api/categories/`)
          .then(response => response.json())
          .then(json => {
            this.categories = json.data
          })
      },
      filterData(){
        this.fetchData(1)
      },
      resetFilerAreaData(){
        this.filterArea = {
          code: null,
          name: null,
          categories: null,
          format: null
        };
        this.fetchData(1)
      },
    },
    computed: {
      items: function () {
        const items = this.tableData;
        return Array.isArray(items) ? items : []
      },
      captions: function () {
        return this.fields
      },
      rowCount: function () {
        return this.tableTotalRows
      },
      categoryFilters: function(){
        if(this.filterArea.categories){
          return this.filterArea.categories.map(a => a.code).join(",");
        }
      }
    },
    created() {
      this.fetchData(1);
      this.getCategories();
      this.getFormats();
    }
  }
</script>
